import { connect } from 'react-redux';
import MyInvestmentsAnalysisComponents from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.myInvestments,
    literalsPerformance: state.i18n.literals.performance,
    literalsCommon: state.i18n.literals.common,
    user: state.session.user,
    shareholders: state.global?.investments?.shareholders,
    currency: state.global?.investments?.currency,
    currencies: state.global?.investments?.currencies,
    lang: state.i18n.language,
  };
}

export default connect(mapStateToProps)(MyInvestmentsAnalysisComponents);
